import { makeStyles } from 'tss-react/mui';

import { CopyText } from 'src/legacy/components/CopyToClipboard';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';

const useStyles = makeStyles()((theme) => ({
  keyValueWrapper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    background: theme.palette.grey[100],
  },
  helperText: {
    marginTop: theme.spacing(1),
  },
}));

export const ApiKey = ({ apiKey }: { apiKey: string }) => {
  const { classes } = useStyles();
  return (
    <>
      <BaseTypography fontType="13Regular" className={classes.helperText}>
        Please copy this key as it will only be visible this one time:
      </BaseTypography>
      <div className={classes.keyValueWrapper}>
        <CopyText value={apiKey} iconPosition="end" spacing="space-between">
          <BaseTypography fontType="13Regular">{apiKey}</BaseTypography>
        </CopyText>
      </div>
    </>
  );
};
